<template>
  <v-container fluid>
    <v-row :no-gutters="true">
      <v-col
        v-for="(cycle, cycle_index) in cycles.filter(c => c.order > 0)"
        :key="cycle_index"
        :cols="$vuetify.breakpoint.mobile ? 12: 'undefined'"
      >
        <div class="text-center font-weight-bold py-2 ">
          {{ cycle.cycle_name }}
        </div>
        <div
          v-if="cycle.modules.length && cycle.modules.length == cycle.expected_modules_qty"
          class="d-flex justify-content-around py-2 border border-gray-100"
        >
          <div
            v-for="(module,key) in cycle.modules"
            :key="key"
          >
            <small class="font-weight-bold text-black">M0{{ key+1 }}</small>
          </div>
          <div>
            <small class="font-weight-bold text-black mx-2">D</small>
          </div>
        </div>
        <div
          v-else
          class="d-flex justify-content-around py-2 border border-gray-100"
        >
          <div
            v-for="(key) in cycle.expected_modules_qty"
            :key="key"
          >
            <small class="font-weight-bold text-black">M0{{ key }}</small>
          </div>
          <div>
            <small class="font-weight-bold text-black mx-2">D</small>
          </div>
        </div>
        <div
          v-if="cycle.modules.length && cycle.modules.length == cycle.expected_modules_qty"
          class="d-flex justify-content-around py-2 border border-gray-100"
        >
          <StatusIcon
            v-for="(module,second_key) in cycle.modules"
            :key="second_key"
            :background="getBackground(module, cycle)"
            :icon="getIcon(module, cycle)"
            tag="span"
          />
          <StatusIcon
            :background="getBackground(cycle.challenge, cycle)"
            :icon="getIcon(cycle.challenge, cycle)"
            tag="span"
          />
        </div>
        <div
          v-else
          class="d-flex justify-content-around py-2 border border-gray-100"
        >
          <StatusIcon
            v-for="(key) in cycle.expected_modules_qty"
            :key="key"
            :background="getBackground()"
            :icon="getIcon()"
            tag="span"
          />
          <StatusIcon
            :background="getBackground(cycle.challenge, cycle)"
            :icon="getIcon(cycle.challenge, cycle)"
            tag="span"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import { mapGetters } from "vuex";
import StatusIcon from "@/student/components/StatusIcon";

export default {
  components: {StatusIcon},
  computed: {
    ...mapGetters(['cycles']),
  },
  methods: {
    getBackground(prop = null, cycle = null) {
      if (!this.wasActive(cycle) || prop === null)
        return 'bg-gray-400';
      if (this.isDone(prop))
        return 'bg-success';
      else
        return 'bg-danger';
    },
    getIcon(prop = null, cycle = null) {
      if (this.isDone(prop))
        return 'fa fa-check';
      if (!this.wasActive(cycle) || prop == null)
        return 'fa fa-lock';
      else
        return 'fa fa-times';
    },
    isDone(prop) {
      if (prop === null)
        return false;
      if (prop.goal_progress >= 100 || (prop.finished_at && prop.count_questions)) {
          return true;
      }
      return false;
    },
    wasActive(cycle) {
      let actual = 0;
      for (let cy of this.cycles) {
        if (cy.is_current) {
          actual = cy.order;
          break;
        }
      }
      return cycle ? cycle.order <= actual : false
    },
  }
}
</script>
